<template>
  <v-dialog v-model="model" persistent max-width="330">
    <v-card>
      <v-card-title>{{ dialogTitle }}</v-card-title>

      <v-card-text class="pre-line">
        {{ dialogText }}
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn variant="text" color="primary" @click="onConfirm"> Confirm </v-btn>

        <v-btn variant="text" color="error" @click="onCancel"> Cancel </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  modelValue: boolean;
  dialogTitle: string;
  dialogText: string;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
  (e: "confirm"): void;
  (e: "cancel"): void;
}>();

const model = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

function onConfirm() {
  emit("confirm");
  model.value = false;
}

function onCancel() {
  emit("cancel");
  model.value = false;
}
</script>

<style scoped>
.pre-line {
  white-space: pre-line;
}
</style>
